import React, { ReactNode } from 'react'

import {
  CubeReportFilterContainer,
  CubeReportPage,
} from 'cube/components/CubeReportFilterContainer'
import CubeReportPageFiltersContext from 'cube/contexts/cubeReportPageFilters.context'
import useCubeReportPageFilters from 'cube/hooks/useCubeReportPageFilters.hook'

import { Box } from '@driftt/dds'

import AppNavigationHeader from 'components/app/AppNavigationHeader'

import { StyledMainContentContainer } from './constants'
interface CubeReportsProps {
  showDatePicker?: boolean
  showReportFilterBar?: boolean
  children: ReactNode
  extraContent: ReactNode | null
  reportType: CubeReportPage
}

const CubeReportsLayout = ({
  children,
  showReportFilterBar,
  showDatePicker,
  extraContent,
  reportType,
}: CubeReportsProps) => {
  const { pageFilters, onChangePageFilters } = useCubeReportPageFilters()

  return (
    <Box className="reports-layout">
      <AppNavigationHeader
        showDatePicker={showDatePicker}
        extraContent={extraContent}
      />
      <CubeReportPageFiltersContext.Provider
        value={{
          pageFilters,
          onChangePageFilters,
        }}
      >
        <StyledMainContentContainer
          fullWidth
          fullHeight
          direction="column"
          gap={2}
        >
          {showReportFilterBar && (
            <CubeReportFilterContainer reportType={reportType} />
          )}
          {children}
        </StyledMainContentContainer>
      </CubeReportPageFiltersContext.Provider>
    </Box>
  )
}

export const withCubeReportsLayout =
  (
    reportType: CubeReportPage,
    showDatePicker = true,
    showReportFilterBar = true,
    extraContent: React.ReactNode = null
  ) =>
  (Component) =>
    function Layout(props) {
      return (
        <CubeReportsLayout
          showReportFilterBar={showReportFilterBar}
          showDatePicker={showDatePicker}
          extraContent={extraContent}
          reportType={reportType}
        >
          <Component {...props} />
        </CubeReportsLayout>
      )
    }

export default CubeReportsLayout
